/**
 *
 * Created at 2021-10-02 11:13
 * @author teapot
 */
import "./index.css";
import { Input, List } from "antd";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { RootState } from "../../../app/store";
import { resetSearchArticles, searchAsync } from "../../../store/HomeStore";
import { useTranslation } from "react-i18next";
import { DetailsParams, SearchArticles } from "../../../model/HomeModel";
import dayjs from "dayjs";
import { useHistory } from "react-router";
import { useEffect } from "react";

const SearchInput = Input.Search;

const Search = () => {
  const { searchArticles } = useAppSelector((state: RootState) => state.home);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const history = useHistory();

  useEffect(() => {
    dispatch(resetSearchArticles())
  }, [dispatch])

  const renderItem = (item: SearchArticles, index: number) => {
    return (
      <List.Item
        key={index}
        onClick={() => {
          history.push("/details", {
            url: item.prefix,
            uuid: item.uuid,
            methods: "get",
          } as DetailsParams);
        }}
      >
        <div className="search-content-title"> {item.author} </div>
        <div className="search-content-time">
          {" "}
          {dayjs(item.publish).format("YYYY-MM-DD")}{" "}
        </div>
        <div className="search-content-desc"> {item.article} </div>
      </List.Item>
    );
  };

  return (
    <div className="search search-width">
      <div className="secrch-input-view search-item">
        <SearchInput
          className="secrch-input"
          onSearch={(value) => {
            dispatch(searchAsync(value));
          }}
        />
      </div>

      {searchArticles.length > 0 ? (
        <>
          <div className="search-item">
            <div className="search-line search-item-placeholder"></div>
            {t("search_res", { count: searchArticles.length })}
            <div className="search-line search-item-placeholder"></div>
          </div>

          <List<SearchArticles>
            className="search-list"
            dataSource={searchArticles}
            itemLayout="vertical"
            renderItem={renderItem}
            locale={{emptyText: t('nodata')}}
          />
        </>
      ) : null}
    </div>
  );
};

export default Search;
